import {SODeleteNotification} from '../../core/notification/so-delete-notification';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteNotification extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteNotification;
}